import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";

export default function SectionHead({ index, kicker, title, en }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={stagger}
      className="mb-12 max-w-3xl sm:mb-16"
    >
      <motion.p variants={fadeUp} className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-vg-green">
        <span className="inline-block h-px w-10 bg-vg-green/60" />
        {index} / {kicker}
      </motion.p>
      <motion.h2 variants={fadeUp} className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-wide text-vg-white sm:text-5xl">
        {title}
      </motion.h2>
      {en && (
        <motion.p variants={fadeUp} className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-vg-muted">
          {en}
        </motion.p>
      )}
    </motion.div>
  );
}
